import { branchService } from '../../services/business/branch.service.js';

export const state = { status: false };

export const actions = {
        async getCollectionPoints({dispatch, commit}) {
        try {

            await branchService.getCollectionPoints().then(response=>{
                if(response.length>0){
                    commit('getShopsSuccess', response);
                    // return response;
                }
            });
           
        } catch (error) {
            commit('getShopsFailure', error);
            dispatch('notification/error', error, { root: true });
        }
    },

        // register the shop
       async authorizeTransaction({ dispatch, commit }, shop) {
            commit('authorizeTransaction', shop);
            return branchService.authorizeTransaction(shop)
                .then(
                    response => {
                        if(response.status=="SUCCESS"){
                            commit('authorizeTransactionSuccess', response.body);
                            dispatch('notification/success', response.message, { root: true });
                            return response;
                        }else{
                            commit('authorizeTransactionFailure', response.message);
                            dispatch('notification/error', response.message, { root: true });
                            return response;
                        }
                    },
                    error => {
                        commit('authorizeTransactionFailure', error);
                        dispatch('notification/error', error, { root: true });
                    }
                );
        },
};

export const mutations = {
    getShopsSuccess(state) {
        state.status = true;
    },
    getShopsFailure(state) {
        state.status = false;
    },
    authorizeTransactionSuccess(state) {
        state.status = true;
    },
    authorizeTransactionFailure(state) {
        state.status = true;
    },
};

